import { Util } from "../Util";
import axios from "axios";
import { AppResponse } from "../models/Response";
import { Order } from "models/Order";
import { AllDriverStatusCount } from "models/AllDriverStatusCount";
import { UpdateDriverRequest } from "models/Driver";

export class DriverService {
  public static async getOrdersByStatus(data: any, limit?: number, offset?: number): Promise<AppResponse<Order[]>> {
    const url = Util.apiAuthUrl(`driver/order/list/` + offset + "/" + limit);
    return await axios.post<void, AppResponse<Order[]>>(url, data);
  }

  public static async getAllDriverStatusCount(): Promise<AppResponse<AllDriverStatusCount>> {
    const url = Util.apiAuthUrl(`driver/order/get-all-status-count`);
    return await axios.post<void, AppResponse<AllDriverStatusCount>>(url);
  }

  public static async acceptOrder(data: UpdateDriverRequest): Promise<AppResponse<string>> {
    const ep = Util.apiAuthUrl("driver/order/accept");
    const res = await axios.post<UpdateDriverRequest, AppResponse<string>>(ep, data);
    return res;
  }
  public static async declineOrder(data: UpdateDriverRequest): Promise<AppResponse<string>> {
    const ep = Util.apiAuthUrl("driver/order/decline");
    const res = await axios.post<UpdateDriverRequest, AppResponse<string>>(ep, data);
    return res;
  }
}
